import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const OrderConfirmation = ({ orderData }) => {
  const orderNumber = "ORD-2025-" + Math.random()?.toString(36)?.substr(2, 9)?.toUpperCase();
  const estimatedDelivery = "Friday, September 29, 2025";
  const trackingNumber = "1Z999AA1" + Math.random()?.toString(36)?.substr(2, 6)?.toUpperCase();

  return (
    <div className="bg-card border border-border rounded-lg p-8 text-center">
      {/* Success Animation */}
      <div className="w-20 h-20 bg-success/20 rounded-full flex items-center justify-center mx-auto mb-6 trust-seal">
        <Icon name="CheckCircle" size={40} className="text-success" />
      </div>

      {/* Success Message */}
      <h1 className="text-3xl font-bold text-foreground mb-2">Order Confirmed!</h1>
      <p className="text-lg text-muted-foreground mb-8">
        Thank you for your purchase. Your order has been successfully placed.
      </p>

      {/* Order Details */}
      <div className="bg-background/50 rounded-lg p-6 mb-8 text-left">
        <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
          <Icon name="Package" size={20} className="mr-2 text-primary" />
          Order Details
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-3">
            <div>
              <span className="text-sm text-muted-foreground">Order Number</span>
              <p className="font-mono font-semibold text-foreground">{orderNumber}</p>
            </div>
            <div>
              <span className="text-sm text-muted-foreground">Order Date</span>
              <p className="font-medium text-foreground">September 23, 2025</p>
            </div>
            <div>
              <span className="text-sm text-muted-foreground">Payment Method</span>
              <p className="font-medium text-foreground">
                {orderData?.paymentMethod === 'card' ? 'Credit Card' : 'PayPal'}
              </p>
            </div>
          </div>
          
          <div className="space-y-3">
            <div>
              <span className="text-sm text-muted-foreground">Estimated Delivery</span>
              <p className="font-medium text-foreground">{estimatedDelivery}</p>
            </div>
            <div>
              <span className="text-sm text-muted-foreground">Tracking Number</span>
              <p className="font-mono font-semibold text-primary">{trackingNumber}</p>
            </div>
            <div>
              <span className="text-sm text-muted-foreground">Total Amount</span>
              <p className="font-bold text-lg text-success">DZ 234,495</p>
            </div>
          </div>
        </div>
      </div>

      {/* Shipping Address */}
      <div className="bg-background/50 rounded-lg p-6 mb-8 text-left">
        <h3 className="font-semibold text-foreground mb-3 flex items-center">
          <Icon name="MapPin" size={16} className="mr-2 text-primary" />
          Shipping Address
        </h3>
        <div className="text-sm text-muted-foreground space-y-1">
          <p className="font-medium text-foreground">{orderData?.firstName} {orderData?.lastName}</p>
          <p>{orderData?.address}</p>
          <p>{orderData?.city}, {orderData?.state} {orderData?.zipCode}</p>
          <p>{orderData?.country}</p>
        </div>
      </div>

      {/* Next Steps */}
      <div className="bg-primary/10 border border-primary/30 rounded-lg p-6 mb-8">
        <h3 className="font-semibold text-foreground mb-4 flex items-center justify-center">
          <Icon name="Info" size={16} className="mr-2 text-primary" />
          What's Next?
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
          <div className="text-center">
            <div className="w-12 h-12 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-2">
              <Icon name="Mail" size={20} className="text-primary" />
            </div>
            <p className="font-medium text-foreground">Email Confirmation</p>
            <p className="text-muted-foreground">Sent to {orderData?.email}</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 bg-warning/20 rounded-full flex items-center justify-center mx-auto mb-2">
              <Icon name="Package" size={20} className="text-warning" />
            </div>
            <p className="font-medium text-foreground">Order Processing</p>
            <p className="text-muted-foreground">1-2 business days</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 bg-success/20 rounded-full flex items-center justify-center mx-auto mb-2">
              <Icon name="Truck" size={20} className="text-success" />
            </div>
            <p className="font-medium text-foreground">Shipping</p>
            <p className="text-muted-foreground">3-5 business days</p>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link to="/user-dashboard">
          <Button variant="default" className="w-full sm:w-auto">
            <Icon name="User" size={16} className="mr-2" />
            View Order Status
          </Button>
        </Link>
        <Link to="/homepage">
          <Button variant="outline" className="w-full sm:w-auto">
            <Icon name="Home" size={16} className="mr-2" />
            Continue Shopping
          </Button>
        </Link>
        <Button variant="ghost" className="w-full sm:w-auto">
          <Icon name="Download" size={16} className="mr-2" />
          Download Receipt
        </Button>
      </div>

      {/* Support Information */}
      <div className="mt-8 pt-6 border-t border-border">
        <p className="text-sm text-muted-foreground mb-2">
          Need help with your order?
        </p>
        <div className="flex items-center justify-center space-x-4 text-sm">
          <a href="mailto:aymenbouz447@gmail.com" className="text-primary hover:underline flex items-center">
            <Icon name="Mail" size={14} className="mr-1" />
            aymenbouz447@gmail.com
          </a>
          <span className="text-muted-foreground">|</span>
          <a href="tel:+213540316604" className="text-primary hover:underline flex items-center">
            <Icon name="Phone" size={14} className="mr-1" />
            +213 5 40 31 66 04
          </a>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;